import type { ParamMatcher } from '@sveltejs/kit'

export const match: ParamMatcher = (param) =>
  /^([a-z][\da-z-]*):([\d]{2}:)?([\d]{2})$/i.test(param)
